import { useMemo } from 'react';

import { useAppSelector } from '@/redux/store';
import { hasPaidMembershipAccess } from '@/utils/membership-access';

export const usePaidMembershipAccess = () => {
  const serviceInfo = useAppSelector((state) => state.user.ServiceInfo);

  return useMemo(() => hasPaidMembershipAccess(serviceInfo), [serviceInfo]);
};
